<!-- ARIA list roles on plain elements: the site's page-level ul/li rules would otherwise restyle the chips -->
@if (tags?.length) {
  <div class="featured-solution-tags" role="list">
    @for (tag of tags; track tag.type) {
      <span class="featured-solution-tag" [class]="'featured-solution-tag tone-' + tag.tone" role="listitem">
        <i-feather class="featured-solution-tag__icon" [name]="tag.icon" aria-hidden="true"></i-feather>
        <span class="featured-solution-tag__label">{{ tag.label }}</span>
      </span>
    }
  </div>
}
